Config.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];

function Config($urlRouterProvider, $urlMatcherFactoryProvider) {
    const shortdateType = {
        encode: function(object) {
            const date = new Date(object);
            date.setHours(12);  //hack for Chrome 46 date issue.  Make sure we are not going back a day in DST by forcing to midday.

            if (isNaN(date.getTime())) {
                return object;
            } else {
                return date.toISOString().slice(0, 10);
            }
        },
        equals: function(a, b) {
            const dateA = new Date(a);
            const dateB = new Date(b);
            //converting to date string to get rid of time portion which we don't care about.  Seems some inputs contain times and some don't
            //which causes data to be loaded twice due to state changing twice.
            return dateA.toDateString() === dateB.toDateString();
        }
    };
    $urlMatcherFactoryProvider.type('shortdate', shortdateType);

    $urlRouterProvider.otherwise('/');
}

export default Config;



// WEBPACK FOOTER //
// ./src/js/core/core.routes.js